<script>
import AkTitleBackgroundText from '@components/v2/general/AkTitleBackgroundText.vue';
import AkLoader from '@components/general/AkLoader.vue';

export default {
  name: 'GaLayoutEmptyTab',
  components: {AkLoader, AkTitleBackgroundText},
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
    classMain: {
      type: String,
      required: false,
    },
  },
  emits: ['init'],
  mounted() {
    this.$emit('init');
  },
};
</script>

<template>
  <div
    class="pt-3 md:px-3 md:mx-auto -mx-1 pb-3 flex flex-col md:gap-12 gap-6 md:min-h-[calc(100vh_-_80px_-_40px)] h-auto">
    <div v-if="false" class="md:flex hidden gap-2 items-center">
      <i class="ga-icon text-[32px] text-grey-900" :class="icon" />
      <span>
        <AkTitleBackgroundText :text="title" class-name="font-bold text-3xl text-grey-900" />
      </span>
    </div>
    <div
      :class="classMain"
      class="flex h-full md:flex-row gap-3 md:gap-0 flex-col md:items-center items-end justify-between rounded-xl w-full overflow-hidden relative"
      :style="`background: ${gradient}; background-color: ${backgroundColor};`">
      <slot name="default" />
    </div>
  </div>
</template>

<style scoped></style>
